import React, { useEffect } from 'react'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import './style.css'

import AS_RU from '../../../assets/images/as_ru.png'
import PM_RU from '../../../assets/images/pm_ru.png'

import Logo from './assets/logo.png'

import Mockup_1280w from './assets/mockup-1280w.png'
import Mockup_768w from './assets/mockup-768w.png'
import Mockup_480w from './assets/mockup-480w.png'

import Group_1280w from './assets/group-1280w.png'
import Group_768w from './assets/group-768w.png'
import Group_480w from './assets/group-480w.png'
import Feedback from '../../../Feedback'

import S1 from './assets/s-1-480w.png'
import S2 from './assets/s-2-480w.png'
import S3 from './assets/s-3-480w.png'
import S4 from './assets/s-4-480w.png'
import S5 from './assets/s-5-480w.png'

const DM = ({ t }) => {

    useEffect(() => {
        document.body.classList.add('dm')

        return () => {
            document.body.classList.remove('dm')
        }
    })

    return (
        <div className="app__content--project">
            <Helmet>
                <title>{ t('dm.name') }</title>
            </Helmet>
            <main className="content__ds">

                <div className="content__ds--intro mt-4">
                    <div className="content__ds--logo-container">
                        <img src={ Logo } alt={ t('dm.name') } className="content__ds--logo" />
                        <div className="content__logos">
                            <a
                                href="https://apps.apple.com/ru/app/dm-control/id1434260188"
                                target="_blank"
                                rel="nofollow noreferrer noopener">
                                <img src={ AS_RU } alt="AppStore ДомАвтоматика" className="content__logos__logo" />
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=one.clockwork.pintwo&hl=ru"
                                target="_blank"
                                rel="nofollow noreferrer noopener">
                                <img src={ PM_RU } alt="Play Market ДомАвтоматика" className="content__logos__logo" />
                            </a>
                        </div>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('dm.text1') }</p>
                    </div>
                </div>

                <div className="content__dm" style={{"--aspect-ratio": "16/9"}}>
                        <iframe
                            className="block__video"
                            src="https://www.youtube.com/embed/4AadNfykFGg"
                            frameBorder={ 0 }
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" />
                </div>

                <div className="content__ds--issue">
                    <div>
                        <h2 className="content__ds--h2">{ t('issue') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('dm.issue') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid">
                    <img
                        srcSet={ `
                ${ Mockup_480w } 480w,
                ${ Mockup_768w } 768w,
                ${ Mockup_1280w } 1280w` }
                        sizes="100vw"
                        src={ Mockup_480w }
                        alt="ДомАвтоматика"
                        className="content__ds--image small" />
                </div>

                <div className="content__ds--solve">
                    <div>
                        <h2 className="content__ds--h2">{ t('solve') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('dm.solve') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid not-mobile">
                    <img
                        srcSet={ `
                ${ Group_480w } 480w,
                ${ Group_768w } 768w,
                ${ Group_1280w } 1280w` }
                        sizes="100vw"
                        src={ Group_480w }
                        alt="ДомАвтоматика"
                        className="content__ds--image" />
                </div>

                <div className="content__ds fluid--flex not-desktop">
                    <img src={ S1 } alt={ t('dm.name') } className="content__ds--logo" />
                    <img src={ S2 } alt={ t('dm.name') } className="content__ds--logo" />
                    <img src={ S3 } alt={ t('dm.name') } className="content__ds--logo" />
                    <img src={ S4 } alt={ t('dm.name') } className="content__ds--logo" />
                    <img src={ S5 } alt={ t('dm.name') } className="content__ds--logo" />
                </div>

                <div className="m-5 ma">
                    <div className="content__logos">
                        <a
                            href="https://apps.apple.com/ru/app/dm-control/id1434260188"
                            target="_blank"
                            rel="nofollow noreferrer noopener">
                            <img src={ AS_RU } alt="AppStore Tommy House" className="content__logos__logo" />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=one.clockwork.pintwo&hl=ru"
                            target="_blank"
                            rel="nofollow noreferrer noopener">
                            <img src={ PM_RU } alt="Play Market Tommy House" className="content__logos__logo" />
                        </a>
                    </div>
                </div>

                <section className="m-5 ma">
                    <Feedback />
                </section>

            </main>
        </div>
    )
}


export default translate('translations')(DM)



// WEBPACK FOOTER //
// ./src/Pages/Projects/DM/index.js